import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(error: any): void {
    console.error('Global Error Handler caught an error:', error);
    
    const rawMessage = error?.message || error?.error?.message || (typeof error === 'string' ? error : '');
    const errorMessage = rawMessage ? this.getLocalizedErrorMessage(rawMessage) : 'Ett oväntat fel uppstod';

    console.warn('Error notification suppressed:', errorMessage);

    if (!environment.production) {
      console.error('Stack Trace:', error?.stack);
      console.error('Full Error Object:', error);
    }
  }

  private getLocalizedErrorMessage(message: string): string {
    const errorMappings: { [key: string]: string } = {
      'Network Error': 'Nätverksfel - kontrollera din internetanslutning',
      'Http failure': 'Serverfel - försök igen senare',
      'Unauthorized': 'Du har inte behörighet för denna åtgärd',
      'Forbidden': 'Åtkomst nekad',
      'Not Found': 'Resursen kunde inte hittas',
      'Internal Server Error': 'Serverfel - kontakta support',
      'Timeout': 'Förfrågan tog för lång tid - försök igen',
      'Connection refused': 'Kan inte ansluta till servern',
      'API Error': 'API-fel uppstod'
    };

    for (const [key, value] of Object.entries(errorMappings)) {
      if (message.toLowerCase().includes(key.toLowerCase())) {
        return value;
      }
    }

    return message.length > 100 ? 'Ett tekniskt fel uppstod' : message;
  }

  // private showErrorNotification(message: string): void {
  //   this.zone.run(() => {
  //     this.notificationService.showError(message);
  //   });
  // }

} 